import { useId } from 'react';
import { FileText, Settings, Truck, ClipboardList } from '../icons/index.jsx';
import './vehiculos.css';

const TABS = [
  { id: 'general', label: 'General', icon: Truck },
  { id: 'documentacion', label: 'Documentación', icon: FileText },
  { id: 'mantenimiento', label: 'Mantenimiento', icon: Settings },
  { id: 'comercial', label: 'Comercial', icon: ClipboardList },
];

export default function VehiculoFormTabs({ activeTab, onChange }) {
  const baseId = useId();

  return (
    <div className="form-tabs" role="tablist" aria-label="Secciones del vehículo">
      {TABS.map(tab => {
        const Icon = tab.icon;
        const tabId = `${baseId}-${tab.id}`;
        return (
          <button
            key={tab.id}
            id={tabId}
            className="form-tabs__tab"
            role="tab"
            type="button"
            aria-selected={tab.id === activeTab}
            onClick={() => onChange(tab.id)}
          >
            <span className="form-tabs__tab-icon">
              <Icon size={18} />
            </span>
            {tab.label}
            {tab.id === activeTab && <span className="form-tabs__indicator" aria-hidden="true" />}
          </button>
        );
      })}
    </div>
  );
}
